import { TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CartItemEffects } from './effects/cart-item.effects';
import { reducers } from './reducers';

@NgModule({
  imports: [
    StoreModule.forFeature('cartItems', reducers),
    EffectsModule.forFeature([CartItemEffects]),
  ],
  providers: [TitleCasePipe],
})
export class CartItemModule {}
